// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, update, create, get } from "./operations.js";
export type {
  FleetspaceListOptionalParams,
  FleetspaceDeleteOptionalParams,
  FleetspaceUpdateOptionalParams,
  FleetspaceCreateOptionalParams,
  FleetspaceGetOptionalParams,
} from "./options.js";
